import { xAxisFormatter } from './GraphBuilder';
import React from 'react';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

type GraphTooltipProps = TooltipProps<ValueType, NameType> & {
    selectedAggregationOptions: string[];
    maxHeight?: number;
};

const GraphTooltip = ({ active, payload, label, selectedAggregationOptions, maxHeight = 150 }: GraphTooltipProps) => {
    if (!active || !payload?.length) return null;

    const filteredPayload = payload
        .filter(
            (entry): entry is typeof entry & { value: number } =>
                typeof entry.value === 'number' && selectedAggregationOptions.includes(entry.dataKey as string)
        )
        .sort((a, b) => b.value - a.value);

    if (filteredPayload.length === 0) return null;

    return (
        <div
            className="bg-white shadow-md rounded text-sm border border-gray-200 overflow-y-auto p-2 min-w-50"
            style={{ maxHeight }}>
            <div className="text-gray-800 mb-1 font-semibold text-sm p-2">{xAxisFormatter(label)}</div>
            <hr className="my-1 border-t border-gray-300" />
            <div className="flex flex-col gap-2">
                {filteredPayload.map((entry, index) => (
                    <div key={`item-${index}`} className="flex items-center gap-4">
                        <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: entry.color }}></span>
                        <span className="text-sm font-sf">{entry.name}</span>
                        <span className="ml-auto  pl-2 text-sm font-medium">{entry.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GraphTooltip;
